<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="specials Other" id="section_other--num_1--seq_5"><p id="rw-p_114619-00001"><a id="pb-rw_5"></a></p><a id="pb-rw_5"> <div class="title-block" id="rw-title-block_114619-00001"> <h1>MISTRESS <br/>BELOW DECK</h1></div> </a><p class="fp" id="rw-p_114619-00002"><a id="pb-rw_5"></a><a id="pb-rw_6"></a></p></div><a id="pb-rw_6">
</a></div><a id="pb-rw_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408913727_other_01.vue?5eb248ce